export default "__VITE_ASSET__Bb0Ut5nm__"